import React from 'react'
import CSSModules from 'react-css-modules'
import styles from './style.module.scss'
import CrowdWorksCompanyName from 'spa/client/components/CrowdWorksCompanyName'

const ClientFooter: React.FC = CSSModules<React.FC>(() => {
  const companyUrl = 'https://crowdworks.co.jp/company/'
  const privacyUrl = 'https://crowdworks.co.jp/privacy_policy'

  return (
    <footer styleName='client-footer'>
      <div styleName='footer-links'>
        <div styleName='about'>
          <a href={companyUrl}>会社概要</a>
        </div>
        <div styleName='privacy-policy'>
          <a href={privacyUrl}>プライバシーポリシー</a>
        </div>
      </div>
      <div styleName='footer-copyright'>
        <div styleName='copyright'>
          copyright (c) CrowdWorks Inc. all rights reserved.
        </div>
        <div styleName='company'>
          運営会社：<CrowdWorksCompanyName />
        </div>
      </div>
    </footer>
  )
}, styles)

export default ClientFooter
